import React, { ReactNode } from 'react';
import { CustomTableCell, CustomTableRow } from './Table';
import { Box } from '@mui/material';
import { ProgressBar } from './ProgressBar';
import { AppCircularProgress } from './page/Loader';

type Props = {
  loading?: boolean;
  message?: ReactNode;
  height?: number;
  bar?: boolean;
};

export const Progress = ({ isBar }: { isBar?: boolean }) => {
  return (
    <Box
      sx={{
        ...(isBar && { position: 'absolute', top: 0, left: 0, width: '100%' }),
      }}
    >
      {isBar ? <ProgressBar /> : <AppCircularProgress />}
    </Box>
  );
};

export const ProgressTableRow = (props: Props) => {
  const { loading, message, height, bar: isBar } = props;
  const loader = <Progress isBar={isBar} />;

  return (
    <CustomTableRow sx={{ height, position: 'relative' }}>
      <CustomTableCell
        colSpan={100}
        sx={{
          textAlign: 'center',
          color: 'light.dark',
          ...(isBar && { p: '0!important' }),
        }}
      >
        {loading ? loader : message}
      </CustomTableCell>
    </CustomTableRow>
  );
};
